export function isUrlPathActive(name) {
    const elems = window.location.pathname.split("/").filter(String);
    return elems.length > 0 && elems[0] === name && (window.location.hostname.match("public_api_1") || window.location.hostname.match("qjumpersjobs.co") || window.location.hostname.match("qjumpers.jobs"));
  }
  
  export function isConfidentialInfo() {
    if (window.location.href.indexOf("link") > 1) {
      return true;
    }
  }
  